import { useTranslation } from "react-i18next";
import { FaChevronLeft } from "react-icons/fa6";
import { RiSettings4Line } from "react-icons/ri";
import Button from "../../../components/buttons/button";
import { useState } from "react";
import Stats from "./stats";
import Popup from "../../../components/popups/popup";
import WorkTimeSetup from "./workTimeSetup";
import WeaklyAttendance from "./weaklyAttendance";
import AttendanceTable from "./attendanceTable";
import { RiDownloadCloudFill } from "react-icons/ri";
import SearchEmployees from "./searchEmployees";
import EmployeeAttendance from "./employeeAttendance";
import Paginate from "../../../components/pagination/paginate";
import SearchSelect from "../../../components/select/searchSelect";
import { useOptions } from "../../../components/hooks/useOptionsHook";
import { useNavigate } from "react-router-dom";

const AttendanceAndLeave = () => {
  const { t } = useTranslation();
  const [openSetup, setOpenSetup] = useState(false);
  const [open, setOpen] = useState(false);
  const data = { last_page: 10 };
  const { paginationOptions } = useOptions();
  const navigate = useNavigate();

  return (
    <main>
      <div className="flex items-center justify-between gap-4 mb-3">
        <div className="flex items-center gap-2">
          <h1
            onClick={() => navigate("/employees")}
            className="text-lg font-bold capitalize cursor-pointer md:text-2xl text-primary"
          >
            {t("employees-1")}
          </h1>
          <FaChevronLeft className="ltr:rotate-180" />
          <p className="font-bold capitalize">{t("attendance")}</p>
        </div>
        <Button
          onClick={() => setOpenSetup(true)}
          className={"bg-primary text-black"}
          type={"button"}
        >
          <RiSettings4Line />
          {t("workingTimeSetup")}
        </Button>
      </div>

      <article className="mt-8 space-y-5">
        <Stats t={t} />
        <WeaklyAttendance t={t} />
        <section className="bg-sideBar rounded-[20px] p-6 grid">
          <div className="flex items-center justify-between">
            <h2 className="text-lg font-bold text-primary">{t("attendance")}</h2>
            <Button
              type={"button"}
              className={"flex items-center gap-2 border border-[#F1F3F8]"}
            >
              <RiDownloadCloudFill size={20} />

              {t("exportPDF")}
            </Button>
          </div>
          <SearchEmployees t={t} />
          <AttendanceTable t={t} setOpen={setOpen} />
        </section>

        <div className="flex items-center gap-2">
          <Paginate data={data} />
          <div>
            <SearchSelect
              options={paginationOptions}
              onChange={(e) => {
                alert("now paginating " + e.value);
              }}
              name={"paginate"}
              placeholder={t("show 10")}
            />
          </div>
        </div>
      </article>
      <Popup open={openSetup} setOpen={setOpenSetup} header={t("workingTimeSetup")}>
        <WorkTimeSetup t={t} setOpen={setOpenSetup} />
      </Popup>
      <Popup open={open} setOpen={setOpen} header={t("attendanceRecord")}>
        <EmployeeAttendance t={t} setOpen={setOpenSetup} />
      </Popup>
    </main>
  );
};

export default AttendanceAndLeave;
